// extracted by mini-css-extract-plugin
module.exports = {"altHero":"hj","altProd":"ij","subheading":"jj","subtext":"kj","extrainfo":"lj","copy":"mj","cta":"nj","disabled":"oj"};